export default __webpack_public_path__ + "static/media/logo_mbf.c4b0f56b.webp";